import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    fontSize: theme.typography.pxToRem(30),
    fontWeight: 600,
    fontFamily: "Inter",
  },
  form: {
    marginTop: 50,
  },
  field: {
    "& .MuiFormLabel-root": {
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.common.black,
    },
    "& .MuiOutlinedInput-root": {
      height: 48,
      fontFamily: "Lato",
      fontStyle: "normal",
      fontWeight: 400,
      color: theme.palette.common.black,
      borderColor: theme.palette.common.black,
      "& fieldset": {
        borderColor: theme.palette.common.black,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.common.black,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.common.black,
        borderWidth: "1px 1px 4px 1px",
      },
    },
    "& label.Mui-focused": {
      color: theme.palette.common.black,
    },
    "& .MuiFormHelperText-root.Mui-error": {
      marginLeft: 0,
    },
  },
  select: {
    width: "100%",
    marginTop: 24,
    marginBottom: 10,
    "& .MuiFormLabel-root": {
      color: theme.palette.common.black,
      fontSize: theme.typography.pxToRem(14),
      fontFamily: "Inter",
      fontWeight: 700,
      fontStyle: "normal",
    },
    "& .MuiInputBase-root": {
      height: 48,
      color: theme.palette.common.black,
      border: "1px solid",
      borderColor: theme.palette.common.black,
      fontFamily: "Lato",
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 400,
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
      "& .MuiSelect-root": {
        "&:focus": {
          height: 28,
          border: "solid",
          borderWidth: "1px 1px 4px 1px",
          borderColor: theme.palette.common.black,
        },
      },
    },
  },
  label: {
    color: theme.palette.common.black,
    fontSize: theme.typography.pxToRem(14),
    fontFamily: "Inter",
    fontWeight: 700,
    fontStyle: "normal",
    marginBottom: 12,
  },
  textArea: {
    width: "100%!important",
    background: "transparent",
    border: "solid",
    padding: 10,
    borderColor: theme.palette.common.black,
    borderWidth: "1px",
    fontSize: theme.typography.pxToRem(16),
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "19.5px",
    "&:focus, &:focus-visible ": {
      border: "solid",
      borderColor: theme.palette.common.black,
      borderWidth: "1px 1px 4px 1px",
      outline: "none",
    },
  },
  datePicker: {
    border: "solid",
    borderColor: theme.palette.common.black,
    borderWidth: 1,
    "& .MuiInputBase-input": {
      "&:focus": {
        border: "solid",
        borderColor: theme.palette.common.black,
        borderWidth: "1px 1px 4px 1px",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  },
  checkbox: {
    "& .MuiTypography-root": {
      fontSize: theme.typography.pxToRem(16),
      fontFamily: "Inter",
      fontWeight: 400,
      lineHeight: "24px",
    },
    "& .MuiButtonBase-root.Mui-checked": {
      color: "black",
    },
  },
  actions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  titleContainer: {
    marginTop: "30px",
    display: "flex",
  },
  footerButtons: {
    display: "flex",
    margin: "20px 0",
  },
  button: {
    padding: "10px 20px",
    borderRadius: "100px",
    backgroundColor: "transparent",
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    fontFamily: "Inter",
    color: "Black",
    "&:hover": {
      color: "black",
      backgroundColor: "#E6F1FF",
    },
    "&:active": {
      color: "black",
      backgroundColor: "#CDE3FF",
    },
    "&.Mui-disabled": {
      color: "#CCCCCC",
      backgroundColor: "transparent",
      "& svg": {
        color: "#CCCCCC",
        filter: "invert(66%)",
      },
    },
  },
  btnDelete: {
    fontFamily: "Lato",
    fontWeight: 400,
  },
  btnCancel: {
    backgroundColor: "#F1F5FF",
    color: "#0344DC",
    marginLeft: 15,
    textDecoration: "none",
  },
  btnSave: {
    backgroundColor: "#0344DC",
    color: "white",
    marginLeft: 30,
    "&:hover": {
      backgroundColor: "#0344DC",
      color: "white",
    },
  },
  btnSaveSuccess: {
    backgroundColor: "#022984",
  },
  snackbarSuccess: {
    backgroundColor: "#E7F9EE",
    border: "1px solid #85DFA9",
  },
  snackbarError: {
    backgroundColor: "#E7F9EE",
    border: "1px solid #F11023",
  },
  alert: {
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(16),
    alignItems: "center",
    width: "100%",
    padding: "15px 16px",
    lineHeight: "24px",
    "&.MuiAlert-standardSuccess": {
      "& .MuiAlert-icon": {
        color: "#0ABF52",
        fontSize: theme.typography.pxToRem(24),
      },
    },
    "&.MuiAlert-standardError": {
      "& .MuiAlert-icon": {
        color: "#F11023",
        fontSize: theme.typography.pxToRem(24),
      },
    },
  },
}));
